<div class="common-card">
  <div class="d-flex align-items-center line-height-1 font-lg fw-bold">
    <ui-delivery-type-icon
      class="d-inline-block me-2"
      [type]="deliveryOrder.type"
    ></ui-delivery-type-icon>

    @if (isToDoor) {
      <span [translate]="'common.delivery.deliveryToDoor'">Delivery to door</span>
    }

    @if (isPickup) {
      <span [translate]="'cart.pickup'">Pick up</span>
    }
  </div>

  <!--For pick up-->
  @if (isPickup) {
    <div class="mt-3 text-muted font-xs line-height-1"
         [translate]="'common.delivery.pickUpLocation'">Outlet
    </div>
    <div class="font-md">
      {{ deliveryOrder.outlet?.name || deliveryOrder.deliveryAddress }}
    </div>

    <div class="mt-3 text-muted font-xs line-height-1"
         [translate]="'common.delivery.pickUpTime'">Pick-up time
    </div>
    <ng-container [ngTemplateOutlet]="defaultDeliveryDateTimeTemplate"></ng-container>
  }

  <!--For delivery to door-->
  @if (isToDoor) {
    @if (deliveryOrder.deliveryUserName) {
      <div class="mt-3 text-muted font-xs line-height-1"
           [translate]="'receipt.recipient'">Recipient
      </div>
      <div class="font-md">{{ deliveryOrder.deliveryUserName }}</div>
    }

    @if (deliveryOrder.deliveryPhone) {
      <div class="mt-3 text-muted font-xs line-height-1"
           [translate]="'titles.contactPhone'">Contact phone
      </div>
      <div class="font-md">{{ deliveryOrder.deliveryPhone }}</div>
    }

    <div class="mt-3 text-muted font-xs line-height-1"
         [translate]="'common.delivery.deliveryAddress'">Delivery address
    </div>

    <div class="font-md">
      {{ deliveryOrder.deliveryAddress }}<br>
      {{ deliveryOrder.deliveryPostNumber }} {{ deliveryOrder.deliveryCity }}
    </div>

    <div class="mt-3 text-muted font-xs line-height-1"
         [translate]="'common.delivery.deliveryTime'">Delivery time
    </div>

    <ng-container [ngTemplateOutlet]="defaultDeliveryDateTimeTemplate"></ng-container>

    @if (deliveryOrder.deliveryNote) {
      <div class="mt-3 text-muted font-xs line-height-1"
           [translate]="'receipt.messageToDriver'">Message to driver
      </div>
      <div class="font-md">{{ deliveryOrder.deliveryNote }}</div>
    }
  }
</div>

@if (isToDoor) {
  <div class="common-card order-info-block-top-border text-end">
  <span class="font-xs text-muted me-2"
        [translate]="'titles.deliveryPrice'">Delivery price</span>
    <span class="font-lg fw-bold">{{ deliveryOrder.price | currencyFormat: currency }}</span>
  </div>
}

<ng-template #defaultDeliveryDateTimeTemplate>
  <ui-order-delivery-time
    class="font-md"
    [deliveryDate]="deliveryOrder.deliveryDate"
    [deliveryTime]="deliveryOrder.deliveryTime"
  ></ui-order-delivery-time>
</ng-template>
